module.exports = __webpack_public_path__ + "assets/img/free_36.1f7188ed.png";